var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAzureVmsSvgrepoCom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#azure-vms-color-16__paint0_linear_2372_267)",
    d: "M14.533 2H1.467A.467.467 0 001 2.467v8.4c0 .257.209.466.467.466h13.066a.467.467 0 00.467-.466v-8.4A.467.467 0 0014.533 2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#50E6FF",
    d: "M10.333 5.306V8.02L8 9.389V6.667l2.333-1.361z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#C3F1FF",
    d: "M10.333 5.306L8 6.674 5.667 5.306 8 3.944l2.333 1.362z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#9CEBFF",
    d: "M8 6.674V9.39L5.667 8.02V5.306L8 6.674z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#C3F1FF",
    d: "M5.667 8.02L8 6.667v2.722L5.667 8.02z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#9CEBFF",
    d: "M10.333 8.02L8 6.667v2.722l2.333-1.369z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#azure-vms-color-16__paint1_linear_2372_267)",
    d: "M10.808 14.157c-1.385-.218-1.44-1.214-1.44-2.824H6.624c0 1.61-.046 2.606-1.43 2.824a.778.778 0 00-.693.777h7a.777.777 0 00-.692-.777z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "azure-vms-color-16__paint0_linear_2372_267",
    x1: 8,
    x2: 8,
    y1: 11.333,
    y2: 2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0078D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#5EA0EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "azure-vms-color-16__paint1_linear_2372_267",
    x1: 8,
    x2: 8,
    y1: 14.934,
    y2: 11.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#CCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#707070"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzureVmsSvgrepoCom);
export default __webpack_public_path__ + "static/media/azure-vms-svgrepo-com.c35372968610727f9434ccfa582d6eb2.svg";
export { ForwardRef as ReactComponent };